import React from "react";
import css from "./about.module.css";
import { BiUserCircle } from "react-icons/bi";
import { FiArrowUpRight, FiMail } from "react-icons/fi";
import Heading from "../../reusable/Heading";
import { about } from "../../../data/about";
import { contact } from "../../../data/contact";
import { sideHeaderElements } from "../../../data/sideHeader";
import useScrollReveal from "../../../hooks/useScrollReveal";

const strengths = [
  {
    number: "01",
    title: "Own features end to end",
    text: "I can move from the interface to APIs, data, integrations, and deployment reducing handoffs and keeping delivery moving.",
  },
  {
    number: "02",
    title: "Make AI useful",
    text: "I turn Gemini and OpenAI capabilities into focused product features with clear inputs, structured outputs, and maintainable application logic.",
  },
  {
    number: "03",
    title: "Build for the next developer",
    text: "I favor reusable components, clear APIs, sensible architecture, and documented decisions over unnecessary complexity.",
  },
];

const About = () => {
  const headingRef = useScrollReveal();
  const contentRef = useScrollReveal();
  const strengthsRef = useScrollReveal();
  const linkedIn = sideHeaderElements[2].socialLinks[2].link;

  return (
    <div className="container px-lg-5" style={{ paddingBottom: "7%" }}>
      <div ref={headingRef} className="reveal">
        <Heading icon={<BiUserCircle />} headingTitle="Why Hire Me" />
      </div>

      <div ref={contentRef} className={`${css.introGrid} reveal`}>
        <h2 className={css.introTitle}>
          One developer who can own the path from product idea to shipped feature.
        </h2>

        <div className={css.introCopy}>
          <p>
            {about.descriptionFirstPart} That range helps me work beyond one
            layer, diagnose problems faster, and contribute wherever the
            product needs momentum.
          </p>
          <p>
            I bring product judgment as well as code: I clarify requirements,
            explain trade-offs, choose practical architecture, and leave a
            codebase the next developer can confidently continue.
          </p>
        </div>

        <dl className={css.facts}>
          <div>
            <dt>Based</dt>
            <dd>{about.from}</dd>
          </div>
          <div>
            <dt>Target roles</dt>
            <dd>Full-stack · Mobile · AI</dd>
          </div>
          <div>
            <dt>Coverage</dt>
            <dd>Frontend to deployment</dd>
          </div>
          <div>
            <dt>Collaboration</dt>
            <dd>Clear, practical, accountable</dd>
          </div>
        </dl>
      </div>

      <div ref={strengthsRef} className={`${css.strengths} reveal`}>
        {strengths.map((strength) => (
          <article key={strength.number} className={css.strength}>
            <span className={css.number}>{strength.number}</span>
            <h3>{strength.title}</h3>
            <p>{strength.text}</p>
          </article>
        ))}
      </div>

      <div className={css.cta}>
        <div>
          <p className={css.ctaLabel}>Ready to contribute</p>
          <h3>Need a developer who can contribute beyond one layer?</h3>
          <p>Let’s discuss the role, your product priorities, and where I can create value from day one.</p>
        </div>
        <div className={css.ctaLinks}>
          <a href={`mailto:${contact.email}`}>
            <FiMail /> Discuss a role
          </a>
          <a href={linkedIn} target="_blank" rel="noopener noreferrer">
            LinkedIn <FiArrowUpRight />
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
